// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PrometheusActionsController = function ($scope, $http, PrometheusAction, SettingsSimulation, $modal) {
    const title = "Prometheus Action";
    SettingsSimulation.get({}, function (data) { $scope.simulationEnabled = data.SimulationEnabled });
    $scope.actions = PrometheusAction.query();

    $scope.areAllActionsSelected = false;
    $scope.selectedAction = "";
    $scope.isIndicatorShown = false;

    function setActionStatus(id, status) {        
        $http.post('/api/v1/prometheusActions/' + id+'/state', { NewStatus: status }).success(function () { $scope.actions = PrometheusAction.query(); });
    }

    function resetTimestamp(id) {
        $http.post('/api/v1/prometheusActions/' + id + '/reset', { State: status }).success(function () { $scope.actions = PrometheusAction.query(); });
    }

    function resetAllTimestamps() {
        if ($scope.actions) {
            for (var i = 0; i < $scope.actions.length; i++) {
                var action = $scope.actions[i];
                if (action !== null && action.State !== null && action.State !== 'Running') {
                    resetTimestamp(action.Id);
                }
            }
        }
    }

    $scope.setActionStatus = function (id, status) {
        $scope.confirm(title, "Are you sure you want to change status to " + status + "?", setActionStatus.bind(this, id, status));
    };

    $scope.resetTimestamp = function (id) {
        $scope.confirm(title, "Are you sure you want to reset timestamp?", resetTimestamp.bind(this, id))
    };

    $scope.resetAllTimestamps = function () {
        $scope.confirm(title, "Are you sure you want to reset all timestamps?", resetAllTimestamps)
    }

    $scope.isSelectedActionApplyButtonDisabled = function () {
        return $scope.isNoActionSelected() || $scope.selectedAction === "";
    }

    $scope.onAllSelectToggle = function() {
        $scope.areAllActionsSelected = !$scope.areAllActionsSelected;
        for(var i = 0; i < $scope.actions.length; i++) {
            $scope.actions[i].isActionSelected = $scope.areAllActionsSelected;
        }
        resetSelectedActionssDropdownSelection();
    }

    $scope.onActionSelectChange = function(action, $event) {
        action.isActionSelected = !action.isActionSelected;
        resetSelectedActionssDropdownSelection();
        $event.stopPropagation();
    }

    function resetSelectedActionssDropdownSelection() {
        if($scope.isNoActionSelected()) {
            $scope.selectedAction = "";
        }      
    }

    $scope.isNoActionSelected = function() {
        return $scope.getNumberOfSelectedActions() === 0;
    }

    $scope.getNumberOfSelectedActions = function() {
        var selectedItems = $scope.actions.filter(x => x.isActionSelected);
        return selectedItems.length;
    }

    $scope.confirmActionsForSelectedActions = function() {
        var action = "";
        switch($scope.selectedAction){
            case "Reenable" : {
                action = "re-enable";
                break;
            }
            case "Pause" : {
                action = "pause";
                break;
            }
            case "ResetTimeStamp" : {
                action = "reset timestamp(s) for";
                break;
            }
            default: throw new Error("Invalid job action");
        }

        var confirmMessage = "Are you sure you want to " + action + " these Action(s)?";
        $scope.confirm("Action", confirmMessage, applySelectedAction);
    }

    function updatePageState () {
        $scope.actions = PrometheusAction.query();
        resetSelectedActionssDropdownSelection();
        $scope.isIndicatorShown = false;
    }

    function applySelectedAction() {
        var selectedActionss = $scope.actions.filter(y => y.isActionSelected);
        var ids =  selectedActionss.map(x => x.Id);
        var action = $scope.selectedAction;
        $scope.isIndicatorShown = true;

        $http.post('/api/v1/prometheusactions/process', {"ActionIds": ids, "JobAction": action}) 
            .then(
                function(response) {
                    updatePageState();
                },
                function(error) {
                    $scope.confirm("Error", "Please navigate the Logs page for the more info.", function(){window.location.href = "/#/logs"});
                    updatePageState();
                }
            );
    }

    var openEditExecutionTimeDialog = function (actionId, actionName, objectToEdit) {
        var modalInstance = $modal.open({
            templateUrl: 'partials/actions/prometheus/edit-execution-time-dialog.html',
            controller: EditExecutionTimeDialogController,
            windowClass: "fade in",
            resolve: {
                id: function () { return actionId; },
                objectToEdit: function () { return objectToEdit; },
                title: function () { return "Execution time configuration for "+actionName; },
                successCallback: function(){ return updatePageState;}
            }
        });
    };    
    
    $scope.editActionExecutionTime = function(actionId, actionName, objectToEdit){
        openEditExecutionTimeDialog(actionId, actionName, objectToEdit);
    };
    
    $scope.formatTimeSpan = function(value){
        if (value) {
            const duration=moment.duration(value);
            //special plugin required to format duration properly
            return duration.days()+"d "+ moment.utc(duration.asMilliseconds()).format("HH:mm");
        }
        return "--:--";
    }

    $scope.formatTime = function(value){
        if (value) {
            const duration = moment.duration(value);
            //special plugin required to format duration properly
            return moment.utc(duration.asMilliseconds()).format("HH:mm");
        }
        return "--:--";
    }    
};
PrometheusActionsController.$inject = ['$scope', '$http', 'PrometheusAction', 'SettingsSimulation', '$modal'];
